
webpack.register(
    'modules/dtm/dtm',
    function() {
        return import('modules/dtm/dtm');
    },
    true
);